import script from "./ProfileCenter.vue?vue&type=script&setup=true&lang=js"
export * from "./ProfileCenter.vue?vue&type=script&setup=true&lang=js"

import "./ProfileCenter.vue?vue&type=style&index=0&id=548a102e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-548a102e"]])

export default __exports__